import {
  SelectionCard,
  SelectionCardActions,
  SelectionCardContent,
  SelectionCardFooter,
  SelectionCardIcon,
  SelectionCardText,
  SelectionCardTitle,
} from '@components/SelectionCard';
import { datadogRum } from '@datadog/browser-rum';
import { Box } from '@spark-web/box';
import { CheckIcon } from '@spark-web/icon';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { TextLinkButton } from '@spark-web/text-link';
import { INCOME_VERIFICATION } from '@utils';
import LockIcon from '../../../../assets/lock.svg?react';

interface OpenBankingIncomeProps {
  onOpenExplanation: () => void;
  onConnect: () => void;
  isLoading?: boolean;
  isCdrChallenger?: boolean;
}

function OpenBankingIncome({ onConnect, isLoading, onOpenExplanation, isCdrChallenger }: OpenBankingIncomeProps) {
  const {
    AUTOFILL_WITH_CDR_TITLE,
    AUTOFILL_WITH_CDR_TITLE_CHALLENGER,
    AUTOFILL_WITH_CDR_DESCRIPTION,
    AUTOFILL_WITH_CDR_DESCRIPTION_CHALLENGER,
    AUTOFILL_WITH_CDR_ACTION,
    AUTOFILL_WITH_CDR_FOOTER_ACTION,
  } = INCOME_VERIFICATION;

  const title = isCdrChallenger ? AUTOFILL_WITH_CDR_TITLE_CHALLENGER : AUTOFILL_WITH_CDR_TITLE;
  const descriptions = isCdrChallenger ? AUTOFILL_WITH_CDR_DESCRIPTION_CHALLENGER : AUTOFILL_WITH_CDR_DESCRIPTION;

  const openExplanationModal = () => {
    datadogRum.addAction('User selected how does it work link');
    onOpenExplanation();
  };

  return (
    <SelectionCard
      border="primary"
      borderWidth="standard"
      borderRadius="medium"
      padding="large"
      display="flex"
      flexDirection="column"
      gap="medium"
    >
      <Box
        alignItems="center"
        gap="small"
        borderRadius="medium"
        background="primaryLow"
        paddingX="large"
        paddingY="medium"
        display="inline-flex"
      >
        <LockIcon />
        <Text weight="semibold" tone="primaryActive" size="small">
          Recommended
        </Text>
      </Box>
      <Stack gap="large" width="full" marginTop="medium">
        <SelectionCardContent marginTop="medium">
          <SelectionCardTitle size="large">{title}</SelectionCardTitle>
          <Stack gap="medium" marginTop={isCdrChallenger ? 'xsmall' : 'none'}>
            {descriptions.map((desc, index) => (
              <Box gap="small" display="flex" alignItems="center" key={index}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <CheckIcon tone="primary" size="xsmall" />
                </Box>
                <SelectionCardText>{desc}</SelectionCardText>
              </Box>
            ))}
          </Stack>
          <Box
            gap="xlarge"
            display="flex"
            flexDirection={{ mobile: 'column', tablet: 'row' }}
            alignItems={{ mobile: 'start', tablet: 'center' }}
            marginTop={isCdrChallenger ? 'none' : 'medium'}
            marginBottom={{ mobile: 'small', tablet: 'none' }}
          >
            <SelectionCardActions
              onClick={onConnect}
              loading={isLoading}
              data={{ testid: 'fill-with-cdr-action-btn' }}
              css={{ width: '100%', '@media (min-width: 740px)': { width: 'auto' } }}
            >
              {AUTOFILL_WITH_CDR_ACTION}
            </SelectionCardActions>
            <Text
              size="small"
              css={{
                width: '100%',
                textAlign: 'center',
                '@media (min-width: 740px)': { width: 'auto', textAlign: 'left' },
              }}
            >
              <TextLinkButton
                weight="regular"
                tone="primaryActive"
                onClick={openExplanationModal}
                data={{ testid: 'open-cdr-explain-modal-btn' }}
              >
                {AUTOFILL_WITH_CDR_FOOTER_ACTION}
              </TextLinkButton>
            </Text>
          </Box>
        </SelectionCardContent>
      </Stack>
    </SelectionCard>
  );
}

export default OpenBankingIncome;
